import { Route, Routes } from "react-router-dom";
import {
  ADDFAVORITES,
  ADDPIXDIRECT,
  ADDSOLICITACAOPAGAMENTO,
  ADDSOLICITACAOTRANSFERENCIA,
  ADDSUPORT,
  ADDVENDADIGITADA,
  ADDVENDADIGITADACARTAO,
  CADASTROCONTASFIXAS,
  CONSULTATRANSACAO,
  CONSULTATRANSACAOCLIENTE,
  CONTASFIXAS,
  CREDITO,
  DADOSPESSOAIS,
  DASHBOARD,
  EDITFAVORITES,
  EXTRACTDETAIL,
  FINANCEIRO,
  FINANCEIROSUPERVISOR,
  LANCAMENTOSFUTUROS,
  LISTADEVENDAS,
  NOVAVENDASBOLETOS,
  PIXDIRECT,
  REGISTERFAVORITES,
  SUPORT,
  TAXASPESSOAIS,
  TRANSFERENCIAS,
  VENDADIGITADA,
  VENDASBOLETO,
  VENDASBOLETOS,
  TRANSFERENCIASNOVO,
  VENDASBOLEPIX,
  NOVAVENDASBOLEPIX,
  NOVAVENDABOLEPIXLOTE,
  ADDSOLICITACAOPAGAMENTONEW,
  ADDSOLICITACAOTRANSFERENCIANEW,
  PAGAMENTOSNOVO,
  LISTADEVENDASTEMPOREAL,
  TERMOSCLIENTES,
} from "../constants/paths";
import NotFound from "../pages/404";
import TermosCarteira from "../pages/termos";
import Credito from "../pages/credito";
import Dashboard from "../pages/dahsboard";
import Financeiro from "../pages/financeiro/extracts";
import ExtractsDetails from "../pages/financeiro/extractsDetails";
import FutureReleases from "../pages/financeiro/futureReleases";
import RegisterFavorites from "../pages/financeiro/registerFavorites";
import AddFavorites from "../pages/financeiro/registerFavorites/components/addFavorites";
import AddTransfer from "../pages/financeiro/transferencias/component/newTransfer";
import TransferSolicitatio from "../pages/financeiro/transferencias/transferSolicitation";
import TransferSolicitatioNova from "../pages/financeiro/transferencias-nova/transferSolicitationNova";
// import Vendas from "../pages/vendas";
import AddPayment from "../pages/vendas/boletos/components/newPayment";
import PaymentSolicitation from "../pages/vendas/boletos/paymentSolicitation";
import AddTransferNew from "../pages/financeiro/transferencias-nova/component/newTransfer";
import PaymentSolicitationNovo from "../pages/vendas/pagamentos-novo/paymentSolicitationNovo";
import SalesListDashboard from "../pages/vendas/listaDeVendas/SalesList";
import VendasBoleto from "../pages/vendas/vendasBoleto";
import VendasDigitadas from "../pages/vendas/vendasDigitadas";
import AddVendaDigitada from "../pages/vendas/vendasDigitadas/components/addVendaDigitada";
import { JWTToken, PrivateRoute } from "./privateRoute";
import { useRecoilState } from "recoil";
import { permissions } from "../atoms/permissions";
import { allPermissions } from "../atoms/allPermissions";
import { useEffect, useState } from "react";
import VendasBolePix from "../pages/vendas/vendaBolePix/index";
import SalesListBolePix from "../pages/vendas/vendaBolePix/SalesListBoleto";
import PaymentLote from "../pages/vendas/vendaBolePix/PaymetLote";
import PermissionsAPI from "../services/permissionsAPI";
import jwt_decode from "jwt-decode";
import EditFavorites from "../pages/financeiro/registerFavorites/components/editFavorites";
import DadosPessoais from "../pages/dadosCliente/dadosPessoais";
import TarifasCliente from "../pages/dadosCliente/ViewPlanos";
import ContaFixa from "../pages/financeiro/contaFixa.tsx";
import AddAccounts from "../pages/financeiro/contaFixa.tsx/components/addAccounts";
import Suport from "../pages/vendas/servicos";
import AddSuport from "../pages/vendas/servicos/components/addSuport";
import SalesListBoleto from "../pages/vendas/vendasBoleto/SalesListBoleto";
import ConsultaTransacoes from "../pages/financeiro/consultaTransacoes";
import AddVendaDigitadaCartao from "../pages/vendas/vendasDigitadas/components/addVendaDigitadaCartao";
import SimplifiedDetailsSupervisor from "../pages/_supervisor/financeiro/extracts/components/simplifiedDetailsSupervisor";
import ConsultaTransacoesClientes from "../pages/_supervisor/financeiro/consultaTransacoes";
import { LoggedUser } from "../atoms/userLogged";
import { selectedClientHeader } from "../atoms/selectedClientHeader";
import ExtratoClienteSupervisor from "../pages/_supervisor/financeiro/consultaTransacoes/components/extratoClienteSupervisor";
import VendasPixDireto from "../pages/vendas/vendasPixDireto";
import AddVendaPixDireto from "../pages/vendas/vendasPixDireto/components/addVendaPixDireto";
import AddPaymentNew from "../pages/vendas/pagamentos-novo/components/newPayment";
import SalesListDashboardTimeReal from "../pages/vendas/listaDeVendasTempoReal/SalesList";
function ComponentRoutes() {
  const permsList = useRecoilState(permissions)[0];
  const [permissionsList, setPermissionsList] = useState(permsList);
  const [isNotEmpty, setIsNotEmpty] = useState(false);

  const token = window.localStorage.getItem("token");

  let jwtToken: JWTToken = jwt_decode(token || "");

  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  // const id = user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  console.log("user", user.idLoginTipo);
  async function getPerms(id: any) {
    try {
      const response = await PermissionsAPI.getPermissions(id);
      setPermissionsList(() => response);
      setIsNotEmpty(!(response.length > 0));
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (
      permissionsList.length === 0 &&
      !isNotEmpty &&
      Number(jwtToken.role) !== 3
    ) {
      getPerms(Number(jwtToken.idCliente));
    }
  }, [permissionsList]);

  return (
    <>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route
          path={TERMOSCLIENTES}
          element={
            <PrivateRoute id={-2} permsList={permissionsList}>
              <TermosCarteira />
            </PrivateRoute>
          }
        />
        <Route
          path={DASHBOARD}
          element={
            <PrivateRoute id={-2} permsList={permissionsList}>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={FINANCEIRO}
          element={
            <PrivateRoute id={9} permsList={permissionsList}>
              <Financeiro />
            </PrivateRoute>
          }
        />
        <Route
          path={EXTRACTDETAIL}
          element={
            <PrivateRoute id={9} permsList={permissionsList}>
              <ExtractsDetails />
            </PrivateRoute>
          }
        />
        <Route
          path={REGISTERFAVORITES}
          element={
            <PrivateRoute id={16} permsList={permissionsList}>
              <RegisterFavorites />
            </PrivateRoute>
          }
        />
        <Route
          path={EDITFAVORITES}
          element={
            <PrivateRoute id={16} permsList={permissionsList}>
              <EditFavorites />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDFAVORITES}
          element={
            <PrivateRoute id={1} permsList={permissionsList}>
              <AddFavorites />
            </PrivateRoute>
          }
        />
        {/* <Route
          path={VENDAS}
          element={
            <PrivateRoute id={19} permsList={permissionsList}>
              <Vendas />
            </PrivateRoute>
          }                     
        /> */}
        <Route
          path={LISTADEVENDAS}
          element={
            <PrivateRoute id={26} permsList={permissionsList}>
              <SalesListDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDSOLICITACAOPAGAMENTONEW}
          element={
            <PrivateRoute id={37} permsList={permissionsList}>
              <AddPaymentNew />
            </PrivateRoute>
          }
        ></Route>
        <Route
          path={TRANSFERENCIASNOVO}
          element={
            <PrivateRoute id={36} permsList={permissionsList}>
              <TransferSolicitatioNova />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDSOLICITACAOTRANSFERENCIANEW}
          element={
            <PrivateRoute id={36} permsList={permissionsList}>
              <AddTransferNew />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGAMENTOSNOVO}
          element={
            <PrivateRoute id={37} permsList={permissionsList}>
              <PaymentSolicitationNovo />
            </PrivateRoute>
          }
        />
        <Route
          path={VENDASBOLEPIX}
          element={
            <PrivateRoute id={2} permsList={permissionsList}>
              <SalesListBolePix />
            </PrivateRoute>
          }
        />
        <Route
          path={NOVAVENDASBOLEPIX}
          element={
            <PrivateRoute id={12} permsList={permissionsList}>
              <VendasBolePix />
            </PrivateRoute>
          }
        />
        <Route
          path={NOVAVENDABOLEPIXLOTE}
          element={
            <PrivateRoute id={12} permsList={permissionsList}>
              <PaymentLote />
            </PrivateRoute>
          }
        />
        <Route
          path={FINANCEIROSUPERVISOR}
          element={
            <PrivateRoute id={9} permsList={permissionsList}>
              <SimplifiedDetailsSupervisor />
            </PrivateRoute>
          }
        />
        <Route
          path={CREDITO}
          element={
            <PrivateRoute id={9} permsList={permissionsList}>
              <Credito />
            </PrivateRoute>
          }
        />
        <Route
          path={VENDASBOLETOS}
          element={
            <PrivateRoute id={12} permsList={permissionsList}>
              <PaymentSolicitation />
            </PrivateRoute>
          }
        />
        <Route
          path={NOVAVENDASBOLETOS}
          element={
            <PrivateRoute id={12} permsList={permissionsList}>
              <VendasBoleto />
            </PrivateRoute>
          }
        />
        <Route
          path={VENDASBOLETO}
          element={
            <PrivateRoute id={12} permsList={permissionsList}>
              <SalesListBoleto />
            </PrivateRoute>
          }
        />
        <Route
          path={VENDADIGITADA}
          element={
            <PrivateRoute id={21} permsList={permissionsList}>
              <VendasDigitadas />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDVENDADIGITADA}
          element={
            <PrivateRoute id={25} permsList={permissionsList}>
              <AddVendaDigitada />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDVENDADIGITADACARTAO}
          element={
            <PrivateRoute id={27} permsList={permissionsList}>
              <AddVendaDigitadaCartao />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDSOLICITACAOPAGAMENTO}
          element={
            <PrivateRoute id={2} permsList={permissionsList}>
              <AddPayment />
            </PrivateRoute>
          }
        />
        <Route
          path={TRANSFERENCIAS}
          element={
            <PrivateRoute id={20} permsList={permissionsList}>
              <TransferSolicitatio />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDSOLICITACAOTRANSFERENCIA}
          element={
            <PrivateRoute id={20} permsList={permissionsList}>
              <AddTransfer />
            </PrivateRoute>
          }
        />
        <Route
          path={LANCAMENTOSFUTUROS}
          element={
            <PrivateRoute id={9} permsList={permissionsList}>
              <FutureReleases />
            </PrivateRoute>
          }
        />
        <Route
          path={DADOSPESSOAIS}
          element={
            <PrivateRoute id={1} permsList={permissionsList}>
              <DadosPessoais />
            </PrivateRoute>
          }
        />
        <Route
          path={TAXASPESSOAIS}
          element={
            <PrivateRoute id={1} permsList={permissionsList}>
              <TarifasCliente />
            </PrivateRoute>
          }
        />
        <Route
          path={CONTASFIXAS}
          element={
            <PrivateRoute id={24} permsList={permissionsList}>
              <ContaFixa />
            </PrivateRoute>
          }
        />
        <Route
          path={CADASTROCONTASFIXAS}
          element={
            <PrivateRoute id={24} permsList={permissionsList}>
              <AddAccounts />
            </PrivateRoute>
          }
        />
        <Route
          path={SUPORT}
          element={
            <PrivateRoute id={24} permsList={permissionsList}>
              <Suport />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDSUPORT}
          element={
            <PrivateRoute id={24} permsList={permissionsList}>
              <AddSuport />
            </PrivateRoute>
          }
        />
        <Route
          path={PIXDIRECT}
          element={
            <PrivateRoute id={33} permsList={permissionsList}>
              <VendasPixDireto />
            </PrivateRoute>
          }
        />
        <Route
          path={ADDPIXDIRECT}
          element={
            <PrivateRoute id={33} permsList={permissionsList}>
              <AddVendaPixDireto />
            </PrivateRoute>
          }
        />

        {user.idLoginTipo === 4 ? (
          <Route
            path={CONSULTATRANSACAO}
            element={
              <PrivateRoute id={9} permsList={permissionsList}>
                <ConsultaTransacoes />
              </PrivateRoute>
            }
          />
        ) : (
          <Route
            path={CONSULTATRANSACAO}
            element={
              <PrivateRoute id={9} permsList={permissionsList}>
                <ConsultaTransacoesClientes />
              </PrivateRoute>
            }
          />
        )}
        <Route
          path={LISTADEVENDASTEMPOREAL}
          element={
            <PrivateRoute id={26} permsList={permissionsList}>
              <SalesListDashboardTimeReal />
            </PrivateRoute>
          }
        />
        {
          <Route
            path={CONSULTATRANSACAOCLIENTE}
            element={
              <PrivateRoute id={9} permsList={permissionsList}>
                <ExtratoClienteSupervisor />
              </PrivateRoute>
            }
          />
        }
      </Routes>
    </>
  );
}
export default ComponentRoutes;
